import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import ContentPopup from '../contentPopup/contentPopup';
import MilitaryDiscount from '../MilitaryDiscount/MilitaryDiscount';
import API from '../../config/config';

const ProductBadgeWidget = (props: any) => {
  const [isClosed, setClosed] = useState(true);
  const [data, setData] = useState(null);
  const onTogglerHandler = (data: any) => {
    setData(data);
    setClosed(!isClosed);
  };
let badgeCount = 0
if(props.data && props.data?.length > 0){
  const badegeFilter = props.data.filter(item => item.label === "Special Offer for our Military, First Responder, Medical, & Educator communities")
  if(badegeFilter?.length > 0){
    badgeCount = props.data?.length - 1
  }else{
    badgeCount = props.data?.length
  }
  
}
  return (
    <>
    {!props.landing && <MilitaryDiscount data={props.data} />}
    <div className={`productbadge-badge-widgte-background ${props.landing && `widget-black-bg`}`}>
      <div className="container-fluid">
        <div className="container">
          <Row xl={badgeCount > 0 ? badgeCount : 3} md={badgeCount > 0 ? badgeCount : 3} 
          sm={badgeCount > 0 ? badgeCount : 3} xs={badgeCount > 0 ? badgeCount : 3}>
            {props.data &&
              props.data
              .filter(item => item.label !== "Special Offer for our Military, First Responder, Medical, & Educator communities")
              .map((item: any, i: number) => {
                return (
                  <Col key={i}>
                    <div className="productbadgeflex-container">
                      <div
                        className="productbadge-img "
                        style={{
                          backgroundImage: `url(${item.icon ? API.baseUrl + item.icon.url : ''})`
                        }}
                      />

                      <h5>{item.label}</h5>
                      <h6 aria-label="subtext"> {props.subtext === true ? item.subTitle : null}</h6>
                      <div
                        className="learn-more"
                        tabIndex={0}
                        onClick={() => {
                          if (props.popup) {
                            onTogglerHandler(item.description);
                          }
                        }}
                      >
                        {item.learnMoreLabel || `Lean More`}
                      </div>
                      {!props.landing && item.description && !item.learnMoreLabel && (
                        <span dangerouslySetInnerHTML={{ __html: item.description }} />
                      )}
                    </div>
                  </Col>
                );
              })}
          </Row>
        </div>
      </div>
      {!isClosed && <ContentPopup data={data} onCloseHandler={onTogglerHandler} />}
    </div>
    </>
  );
};

export default ProductBadgeWidget;
